import { createSelector } from 'reselect'
import { selectPlans } from './selectPlans'
import { selectPendingDowngrades } from './selectPendingDowngrades'

export const selectPendingDowngradePlans = createSelector(
  selectPendingDowngrades,
  selectPlans,
  (pendingDowngrades, plans) => {
    return {
      inbox: pendingDowngrades.inbox
        ? plans.find(p => p.planId === pendingDowngrades.inbox.planId)
        : null,
      kb: pendingDowngrades.kb
        ? plans.find(p => p.planId === pendingDowngrades.kb.planId)
        : null,
    }
  }
)
